export const APP_CONSTANTS = {
  API_URL: "https://api.payerconnect.zsservices.com",
  Logout_URL:
    "https://idm.zsservices.com/ValueAccess/IdentityManager/app/Web/logout.aspx?returnUrl=https://payerconnect.zsservices.com/",
};
